import styled from 'styled-components';
import { Row } from '../../common';

export const Wrapper = styled(Row)`
  display: flex;
  min-height: calc(100vh - 140px);
  color: white;

  @media (max-width: 960px) {
    // flex-direction: column;
  }
`;

export const IntroWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

export const Details = styled.div`
  flex: 1;

  @media (max-width: 960px) {
    width: 100%;
    margin-bottom: 2rem;
  }

  h1 {
    margin-bottom: 2rem;
    font-size: 36pt;
    color: #212121;

    @media (max-width: 680px) {
      font-size: 30pt;
    }
  }

  h4 {
    margin-bottom: 2.5rem;
    font-size: 32pt;
    font-weight: normal;
    color: #707070;

    @media (max-width: 680px) {
      font-size: 26pt;
    }
  }
`;

export const Thumbnail = styled.div`
  flex: 1;

  @media (max-width: 960px) {
    width: 100%;
  }

  img {
    width: 100%;
  }
`;

export const DescriptionContainer = styled.div`
  padding-top: 125px;
  padding-left: 120px;


  @media (max-width: 960px) {
    padding-top: 65px;
    padding-left: 32px;
  }
`;